import { isObject } from 'lodash'
import moment from 'moment'

/**
 * 계좌번호를 입력 받아서 은행코드를 return
 */
export const returnBankCode = (
    acn: string
): {
    BANK_CD: string
    BANK_NM: string
    pattern: RegExp
}[] => {
    if (isEmpty(acn)) {
        return []
    }

    let acnString = getNumberOnly(acn)

    // 추천은행목록
    let aRcmdBankList = [
        {
            BANK_CD: '003',
            BANK_NM: '기업은행',
            pattern:
                /^\d{10}$|^\d{11}$|^\d{3}([0][1-6]|13|29|93|97)\d{7}$|^\d{9}([0][1-7]|[1][3-5]|17|19|20|23|24|28|29|74|75|77|[8][1-3]|93|94|96|97)\d{3}$/,
        },
        {
            BANK_CD: '004',
            BANK_NM: '국민은행',
            pattern:
                /^(0)\d{9}$|^(0)\d{10}$|^(9)\d{10}$|^\d{4}(04|05|06|18)\d{6}$|^\d{3}(01|[0][4-6]|[1][2-5]|18|19|21|[2][4-6]|28|29|30|41)\d{7}$|^\d{4}(01|02|03|07|23|[2][5-7]|37|41|42|45|48|49|[5][1-3]|[5][5-8]|89|90|92|99)\d{8}$/,
        },
        {
            BANK_CD: '081',
            BANK_NM: '하나은행',
            pattern:
                /^\d{9}$|^\d{10}$|^\d{11}$|^\d{12}$|^\d{13}$|^\d{12}(01|02|04|05|07|08|12|13|21|23|25|26|37|[5][0-3]|[5][5-9]|60|94)\d{0}$/,
        },
        {
            BANK_CD: '088',
            BANK_NM: '신한은행',
            pattern:
                /^\d{10}$|^\d{6}([0][1-9]|[1][0-3]|17|20|21|[2][3-8]|33|36|37|[4][0-6]|61|99)\d{6}$|^([1][0][0-9]|[1][1][0-9]|[1][2][0-9]|[1][3][0-9]|[1][4][0-9]|[1][5][0-9]|[1][6][0-1]|221|223|230|[2][3][2-6]|239|[2][4-6][0]|268|269|[2][7][0-2]|[2][7][5-7]|[2][8][0-4]|287|290|298])\d{9}$|^\d{3}(81|82)\d{8}$|^([5][6][0-9])\d{11}$|^\d{3}(901)\d{8}$/,
        },
        {
            BANK_CD: '020',
            BANK_NM: '우리은행',
            pattern:
                /^\d{10}$|^\d{11}$|^(2)\d{11}$|^\d{3}(01|04|05|09|15|21|24|25|28|29|30|32|41)\d{7}$|^\d{1}([0][0][2-7]|020|[0][4][0-3]|046|047|[0][7][1-3]|093|096|104|[1][0][6-9]|110|[1][1][4-6]|[1][2][0-2]|130|181|191)\d{9}$|^\d{9}([0][1-4]|06|07|12|13|15|16|18|24|30|31|33|38|39|43|45|52|57|58|[6][1-7]|82|92|95)\d{3}$/,
        },
        {
            BANK_CD: '090',
            BANK_NM: '카카오뱅크',
            pattern:
                /^\d{9}$|^\d{10}$|^\d{11}$|^\d{1}(300|320|333|355|377)\d{9}$|^(7777)\d{9}$/,
        },
        {
            BANK_CD: '092',
            BANK_NM: '토스뱅크',
            pattern: /^(100|150|300)\d{9}$/,
        },
        {
            BANK_CD: '089',
            BANK_NM: '케이뱅크',
            pattern: /^(9)\d{9}$|^\d{11}$|^\d{12}$|^\d{13}$|^\d{14}$/,
        },
        {
            BANK_CD: '031',
            BANK_NM: 'iM[구 대구은행]',
            pattern:
                /^\d{7}$|^\d{8}$|^\d{9}$|^\d{10}$|^\d{3}(01|02|04|05|07|08|19|20|21|25|27|28|[6][0-2]|[6][4-6]|68|69|70|73|75)\d{7}$|^(501|502|504|505|508|519|520|521|524|525|527|528|560|561|562|564|566|568|570|573|575|578|579|598)\d{9}$|^\d{3}(01|02|05|06|11|19)\d{8}$|^([9][1-4]|96|97)\d{11}$|^\d{3}(01|02|[0][4-8]|19|[2][0-2]|25|27|28|52|55|57|[6][1-5]|[9][1-4]|96)\d{9}$|^(937)\d{11}$/,
        },
        {
            BANK_CD: '002',
            BANK_NM: '산업은행',
            pattern:
                /^\d{3}(11|13|15|18|19|22|25|27|43|47|51|52|55|[6][0-2])\d{6}$|^(010|011|013|018|019|020|022|[0][3][1-7]|[0][7][0-9]|080|086|143|147|151|152|154|155|158|159|[1][6][0-2]|164|168|270)\d{11}$/,
        },
        {
            BANK_CD: '007',
            BANK_NM: '수협',
            pattern:
                /^\d{14}$|^\d{3}([0][1-3]|06|08|13|17|18|23|24|26|27|31|35|36|[4][3-5]|47|49|59|[6][1-4]|[6][6-8]|74|75|78|[8][1-5]|93|97)\d{6}$|^([1][0][1-3]|106|108|206|113|114|[1][4][0-2]|149|167|169|170|175|190|195|201|202|208|209|240|242|[2][4][6-9]|[9][4][3-5]|947|949|970|974|975|978|[9][8][0-5]|987|990|993)\d{9}$|^(0)\d{11}$/,
        },
        {
            BANK_CD: '011',
            BANK_NM: '농협은행',
            pattern:
                /^\d{10}$|^\d{3}(01|02|[0][4-6]|10|12|14|17|21|24|28|31|34|43|[4][5-7]|49|59|79|80|81|[8][6-8]|90)\d{6}$|^\d{4}(01|02|[0][4-6]|10|12|14|17|21|24|28|31|34|43|[4][5-7]|49|59|79|80|81|[8][6-8]|90)\d{6}$|^(028|031|032|043|046|079|081|[0][8][6-8]|090|097|301|302|[3][0][4-6]|310|312|314|317|321|324|334|345|347|349|359|380)\d{10}$|^\d{6}(64|65)\d{6}$|^(790|791)\d{11}$/,
        },
        {
            BANK_CD: '012',
            BANK_NM: '지역농축협',
            pattern:
                /^\d{10}$|^(028|351|352|354|355|356|360|384|394|398)\d{10}$|^\d{6}(51|52|[5][4-6]|60|66|67|84|94|98)\d{6}$|^(792)\d{11}$/,
        },
        {
            BANK_CD: '023',
            BANK_NM: 'SC은행',
            pattern:
                /^\d{3}(10|15|17|20|30|46|48|49|53|54|58|59|61|70|76|90)\d{6}$|^\d{3}(16)\d{9}$/,
        },
        {
            BANK_CD: '027',
            BANK_NM: '한국씨티은행',
            pattern:
                /^(0|5)\d{9}$|^\d{2}([0-1][0-9]|20|21|30|[3][2-5]|[3][5-8]|[4][0-6]|48|[5][0-9]|[6][0-9]|70|[7][1-8]|80|81|83|[8][4-8]|[9][1-6]|99)\d{6}$|^\d{8}(01|03|[0][5-7]|11|13|15|16|18|19|20|21|[2][3-7]|29|31|33|[3][7-9]|[4][1-3]|51|[5][3-5]|58|61|63|66|67|71|[8][1-4]|[9][0-2]|99)\d{1}$|^(9)\d{11}$|^(9)\d{13}$|^\d{8}(18|24|25|41)\d{2}$|^\d{8}(01|03|[0][5-7]|11|13|15|16|18|19|20|21|[2][3-7]|29|31|33|[3][7-9]|[4][1-3]|51|[5][3-5]|58|61|63|66|67|71|[8][1-4]|[9][0-2]|99)\d{3}$|^\d{4}(91|92|93)\d{8}$/,
        },
        {
            BANK_CD: '032',
            BANK_NM: '부산은행',
            pattern:
                /^\d{8}$|^\d{9}$|^\d{10}$|^\d{11}$|^\d{2}([0][1-4]|06|07|09|[1][1-4]|[1][6-8]|21|23|24|27|49|53|[9][0-5])\d{7}$|^([1][0][1-4]|106|107|109|[1][1][1-4]|[1][1][6-8]|121|123|124|127|149|153|[6][9][0-5])\d{10}$/,
        },
        {
            BANK_CD: '034',
            BANK_NM: '광주은행',
            pattern:
                /^\d{3}(01|02|03|05|20|37)\d{6}$|^\d{3}(101|103|[1][0][7-9]|[1][2][1-4]|127|133|135|138|140|145|148|150|151|[4][0-9][0-8]|710|712|714|716|718|[7][2][1-3]|726|727|729|730|731|[7][3][6-8]|[7][4][1-4]|776)\d{6}$|^(80)\d{10}$|^(810)\d{9}$|^(811)\d{9}$|^(812)\d{9}$|^(813)\d{9}$|^(814)\d{9}$|^\d{1}(101|103|107|109|121|127|133|134|135|137|138|140|145|148|150|151|710|712|714|716|718|[7][2][1-9]|730|731|733|[7][3][6-8]|[7][4][1-4]|[7][5][1-3]|776)\d{9}$/,
        },
        {
            BANK_CD: '035',
            BANK_NM: '제주은행',
            pattern:
                /^(0)\d{8}$|^(0)\d{9}$|^\d{2}([0][1-5]|07|11|[1][3-7]|20|21|44|49|[5][5-9]|63|64)\d{6}$|^(0)\d{10}$|^(0)\d{11}$|^([7][0][0-9]|[7][1][1-4]|769|[7][3][0-7]|[7][4][0-5]|747|749|[7][5][0-3]|[7][7][0-9]|844|849|[8][5][5-9]|863|864)\d{9}$|^\d{2}([9][0-9])\d{10}$/,
        },
        {
            BANK_CD: '037',
            BANK_NM: '전북은행',
            pattern:
                /^\d{9}$|^\d{10}$|^\d{11}$|^\d{3}([0][1-3]|08|[1][1-3]|15|19|[2][0-5]|27|28|[3][0-9]|41|[5][2-7]|[6][0-2]|66|67)\d{7}$|^\d{1}([0][1][1-3]|015|021|023|024|031|033|039|041|060|064|[0][6][6-9])\d{9}$/,
        },
        {
            BANK_CD: '039',
            BANK_NM: '경남은행',
            pattern:
                /^\d{8}$|^\d{9}$|^\d{10}$|^\d{11}$|^\d{3}(01|03|07|09|17|19|[2][0-2]|[2][4-7]|29|31|32|[3][4-6]|39|41|42|44|46|49|53|57|64|65|70|79|97)\d{7}$|^(201|203|207|209|[2][2][0-2]|225|226|229|231|232|[2][3][4-6]|241|346|379|[3][8][0-2]|[8-9][0-9][0-9])\d{10}$/,
        },
        {
            BANK_CD: '045',
            BANK_NM: '새마을금고',
            pattern:
                /^\d{4}(09|10|13|37)\d{7}$|^([9][0][0][2-5]|9070|9072|[9][0][9][0-9]|9200|9202|9205|[9][2][0][7-9]|9210|[9][2][1][2-9]|9220)\d{9}$|^\d{4}([8][0][1-9]|810|[8][5][1-9]|860)\d{7}$/,
        },
        {
            BANK_CD: '048',
            BANK_NM: '신협',
            pattern:
                /^\d{10}$|^\d{11}$|^(110|[1][3][1-8]|[1][7][0-4]|177|178|179|[1][8][0-7]|731|910|980])\d{9}$|^\d{5}(12|13)\d{6}$|^\d{5}(14)\d{7}$/,
        },
        {
            BANK_CD: '050',
            BANK_NM: '상호저축은행',
            pattern: /^\d{11}$|^\d{5}(13|15|[2][1-3]|[3][0-9])\d{7}$/,
        },
        {
            BANK_CD: '054',
            BANK_NM: 'HSBC',
            pattern:
                /^\d{9}([0][0][1-9]|010|[0][2][1-9]|030|[0][6][6-9]|072|073|[0][7][6-9]|083|[0][8][6-9]|091|092|[1][8][0-2]|[1][8][4-6]|[2][2][1-3]|[2][9][6-7]|[3][0][6-7]|407|[4][6][1-5]|[7][0][2-3]]|[7][1][1-2]|[7][8][3-4]|863|[9][0][0-3]|[9][8][5-9]|[9][9][0-4])\d{0}$/,
        },
        { BANK_CD: '055', BANK_NM: '도이치', pattern: /^\d{10}$/ },
        { BANK_CD: '057', BANK_NM: 'JP모간', pattern: /^\d{10}$|^\d{14}$/ },
        { BANK_CD: '058', BANK_NM: '미즈호', pattern: /^(H10|H15)\d{9}$/ },
        {
            BANK_CD: '059',
            BANK_NM: '엠유에프지',
            pattern:
                /^\d{2}(1000|1710|1720|2000|6000)\d{6}$|^\d{3}(31|32)\d{8}$/,
        },
        { BANK_CD: '060', BANK_NM: 'BOA', pattern: /^\d{12}$|^\d{14}$/ },
        { BANK_CD: '062', BANK_NM: '중국공상은행', pattern: /^\d{14}$/ },
        { BANK_CD: '063', BANK_NM: '중국은행', pattern: /^\d{9}$/ },
        {
            BANK_CD: '064',
            BANK_NM: '산림조합',
            pattern:
                /^\d{14}$|^\d{2}([1][1-5]|21|23|24|[2][6-9])\d{7}$|^\d{5}(21|22|[2][4-7]|30|[3][2-4])\d{6}$/,
        },
        { BANK_CD: '067', BANK_NM: '중국건설은행', pattern: /^\d{12}$/ },
        {
            BANK_CD: '071',
            BANK_NM: '우체국',
            pattern:
                /^(100|110|120|190|300|310|[3][2][0-5]|[5][3][0-5])\d{9}$|^(8)\d{12}$|^(9)\d{12}$|^\d{6}(01|02|03|05|06|[1][2-4]|17|18|[3][1-3]|[4][0-9]|52|[8][0-9]|97)\d{6}$/,
        },
        {
            BANK_CD: '209',
            BANK_NM: '유안타증권',
            pattern: /^\d{12}$|^\d{3}([0][0-9]|10|13|33|51|53|55|71|76)\d{6}$/,
        },
        {
            BANK_CD: '218',
            BANK_NM: 'KB증권',
            pattern: /^\d{9}$|^\d{10}$|^\d{11}$/,
        },
        {
            BANK_CD: '238',
            BANK_NM: '미래에셋증권',
            pattern:
                /^\d{8}$|^\d{9}$|^\d{10}$|^\d{11}$|^\d{12}$|^\d{13}$|^\d{14}$/,
        },
        {
            BANK_CD: '240',
            BANK_NM: '삼성증권',
            pattern:
                /^\d{8}$|^\d{9}$|^\d{10}$|^\d{11}$|^\d{12}$|^\d{13}$|^\d{14}$/,
        },
        {
            BANK_CD: '243',
            BANK_NM: '한국투자',
            pattern:
                /^\d{8}$|^\d{9}$|^\d{10}$|^\d{11}$|^\d{12}$|^\d{13}$|^\d{14}$/,
        },
        { BANK_CD: '247', BANK_NM: 'NH농협증권', pattern: /^\d{11}$/ },
        {
            BANK_CD: '261',
            BANK_NM: '교보증권',
            pattern:
                /^(0)\d{2}(01|31|35|51|53|54|[6][0-9]|71|80)\d{6}$|^(1)\d{10}$|^(2)\d{10}$|^(3)\d{10}$|^(4)\d{10}$|^(5)\d{10}$|^(6)\d{10}$|^(7)\d{10}$|^(8)\d{10}$|^(9)\d{10}$/,
        },
        {
            BANK_CD: '262',
            BANK_NM: '아이엠증권',
            pattern: /^\d{8}$|^\d{8}([0-9][1-9]|[1-9][0])\d{0}$/,
        },
        { BANK_CD: '263', BANK_NM: '현대차증권', pattern: /^\d{8}$|^\d{10}$/ },
        {
            BANK_CD: '265',
            BANK_NM: 'LS증권',
            pattern:
                /^\d{9}$|^\d{2}(01|11|45|46|51|55|56|64|77|78|88|91)\d{6}$/,
        },
        { BANK_CD: '266', BANK_NM: 'SK증권', pattern: /^\d{9}$|^\d{11}$/ },
        { BANK_CD: '267', BANK_NM: '대신증권', pattern: /^\d{9}$|^\d{11}$/ },
        {
            BANK_CD: '269',
            BANK_NM: '한화투자증권',
            pattern: /^\d{10}$|^\d{11}$|^\d{13}$|^\d{14}$/,
        },
        {
            BANK_CD: '270',
            BANK_NM: '하나증권',
            pattern: /^\d{8}$|^\d{10}$|^\d{11}$|^\d{14}$/,
        },
        {
            BANK_CD: '278',
            BANK_NM: '신한투자증권',
            pattern: /^(0)\d{9}$|^(0)\d{10}$/,
        },
        { BANK_CD: '279', BANK_NM: 'DB금융투자', pattern: /^\d{9}$|^\d{11}$/ },
        { BANK_CD: '280', BANK_NM: '유진투자증권', pattern: /^\d{11}$/ },
        {
            BANK_CD: '287',
            BANK_NM: '메리츠증권',
            pattern: /^\d{10}$|^\d{3}(01|21|53|54|88)\d{6}$/,
        },
        { BANK_CD: '288', BANK_NM: '카카오페이증권', pattern: /^\d{11}$/ },
        { BANK_CD: '291', BANK_NM: '신영증권', pattern: /^\d{9}$|^\d{12}$/ },
    ]

    const result = aRcmdBankList.filter((item) => item.pattern.test(acnString))

    return result
}

/**
 * 관리자에서 > 서버로 보낼때 역치환
 *
 *
 *
 */
export const convertToHtml = (str1: string): string => {
    return str1
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&apos;/g, '')
        .replace(/&quot;/g, '"')
}

/**
 * String이 비었는지 여부
 * @param str
 * @returns {Boolean}
 */
export const isNullorEmptyString = (str: string): boolean => {
    if (
        typeof str === 'undefined' ||
        str === null ||
        str.length === 0 ||
        str === ''
    ) {
        return true
    } else {
        return false
    }
}

/**
 * 날짜정보
 *
 * @fix
 * 2025.05.23 최성웅 기업은행 모바일 브랜치 공통 가이드로 인한 yearFormater : "." 변경
 *
 */
const _dateInfo = {
    arrDay: [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    arrWeekStr: ['일', '월', '화', '수', '목', '금', '토'],
    arrWeekEngStr: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    yearFormater: '.', // 일자 포맷터
    timeFormater: ':', // 시간 포맷터
}

/**
 * null 여부 검사
 * @param {any} obj  string or object
 * @return  Boolean
 */
export const isNull = (obj?: any): boolean => {
    return (
        typeof obj === 'undefined' ||
        obj === null ||
        obj === '' ||
        obj === 'null'
    )
}

/**
 * 공백여부 반환 TODO: 이거 val이 {}면 trim에서 에러남 수정해야됨.(사용 중인 곳이 있음)
 * @param val 검증대상
 * @returns
 *
 * 2025.06.25 Object trim 예외 처리.
 */
export const isEmpty = (val: any = ''): boolean => {
    if (isObject(val)) {
        if (val === null || val === undefined) return true
    } else {
        if (val === null || val === undefined || val.trim() === '') return true
    }

    return false
}

/**
 * 문자열중 숫자만 반환<br/>
 * 날짜, 시간, 주민번호, 전화번호등에서 사용
 * @param {string | number} num 수치문자열
 * @return  String  숫자로된 문자열
 * @example
 *     ex1) getNumberOnly("590101-1234567") ==> '5901011234567'
 *     ex2) getNumberOnly("02-345-7895") ==> '023457895'
 */
export const getNumberOnly = (num: string | number) => {
    return String(num).replace(/[^0-9]/g, '')
}

/**
 * 문자열중 한글, 영문, 공백만 반환<br/>
 * 이름에서 사용
 * @param {string} str 문자열
 * @return  String  한글, 영문, 공백으로만 구성된 문자열
 */
export const getNameOnly = (str: string): string => {
    return str.replace(
        // /[^\uFE55\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55\u3131\u314E\u313F\u3163ㄱ-ㅎ가-힣a-zA-Z\s]+$/g,
        /[^\u1100-\u1112\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z\s]$/g,
        ''
    )
}

/**
 * 한글만 반환
 * @param str
 * @returns
 */
export const getKorOnly = (str: string): string => {
    return str.replace(
        // /[^\uFE55\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55\u3131\u314E\u313F\u3163ㄱ-ㅎ가-힣a-zA-Z\s]+$/g,
        /[^\u1100-\u1112\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55ㄱ-ㅎ가-힣\s]+$/g,
        ''
    )
}

/**
 * 영어만 반환
 * @param str
 * @returns
 */
export const getEngOnly = (str: string): string => {
    return str.replace(
        // /[^\uFE55\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55\u3131\u314E\u313F\u3163ㄱ-ㅎ가-힣a-zA-Z\s]+$/g,
        /[^\u1100-\u1112\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55ㄱ-ㅎ가-힣\s]+$/g,
        ''
    )
}

/**
 * 문자열 왼쪽에 일정길이(maxLen) 만큼 특별한문자(default: 0)로 채우기
 * @param {string} str 문자열
 * @param {number} maxLen  문자로 채울 최대 길이
 * @param {string} usrChar 채울문자 (default: 0)
 * @return  String  문자열
 * @example
 *     fillZero("24", 4) => 0024
 * @deprecated String.padStart() 사용
 */
export const fillZero = (
    str: string | number,
    maxLen: number,
    usrChar: string = '0'
): string => {
    const tmpStr = String(str).trim()
    let zero = ''
    const fillChar = usrChar
    if (tmpStr.length < maxLen) {
        for (let i = tmpStr.length; i < maxLen; i++) {
            zero += fillChar
        }
    }

    return zero + '' + tmpStr
}

/**
 * 브라우져 종류 반환
 * @return  String  browser종류 (MSIE, Chrome, Safari, Opera, Firefox 중 택일: webUtil.getBrowserCheck()와는 다름)
 * @example
 *     getBrowser()
 */
// export const getBrowser = function () {
//     var result = "";

//     if (navigator.appName.match(/Explorer/i) != null || navigator.userAgent.match(/Trident/i) != null || navigator.userAgent.match(/MSIE/i) != null) {
//         result = "MSIE";
//     }
//     if (navigator.userAgent.match(/Firefox/i) != null || (navigator.userAgent.match(/Gecko/i) != null && navigator.userAgent.match(/AppleWebKit/i) == null)) {
//         result = "Firefox";
//     }
//     if (navigator.userAgent.match(/Opera/i) != null) {
//         result = "Opera";
//     }
//     if (result != "MSIE" && (navigator.userAgent.match(/Chrome/i) != null)) {
//         result = "Chrome";
//     }
//     if (typeof navigator.vendor != "undefined") {
//         if (navigator.vendor.indexOf("Apple") > -1) {
//             result = "Safari";
//         }
//     }
//     if (result == "") {
//         result = "MSIE";
//     }

//     return result;
// };

/*날짜 포맷 
형식 'yyyymmdd'  >  'yyyy-mm-dd'  
*/
export const formatIosDate = (dateStr: string): string => {
    if (!/^\d{8}$/.test(dateStr)) {
        throw new Error('Invailid YYYYMMDD format')
    }
    const year_ = dateStr.slice(0, 4)
    const month_ = dateStr.slice(4, 6)
    const day_ = dateStr.slice(6, 8)

    const rst_ = year_ + '-' + month_ + '-' + day_

    return rst_
}

export const formatIosCommaDate = (dateStr: string): string => {
    const year_ = dateStr.slice(0, 4)
    const month_ = dateStr.slice(4, 6)
    const day_ = dateStr.slice(6, 8)

    const rst_ = year_ + '.' + month_ + '.' + day_

    return rst_
}

/*D-day 계산 
targetDateStr : 'yyyy-mm-dd'  
*/
export const calculateDDay = (targetDateStr: string): string => {
    const today = new Date()
    const targetDate = new Date(targetDateStr)

    today.setHours(0, 0, 0, 0)
    targetDate.setHours(0, 0, 0, 0)

    const diffTime = targetDate.getTime() - today.getTime()
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays === 0) return 'day'
    else return diffDays.toString()
}

/**
 * 현재 시간이랑 서버시간 비교
 * @param  {string} 14자리 yyyymmddhhmmss
 * @return  true / false
 * @example
 *
 **/
export const isFutureTime = (dateStrr: string): boolean => {
    const year_ = dateStrr.slice(0, 4)
    const month_ = dateStrr.slice(4, 6)
    const day_ = dateStrr.slice(6, 8)
    const hour_ = dateStrr.slice(8, 10)
    const minute_ = dateStrr.slice(10, 12)
    const second_ = dateStrr.slice(12, 14)

    const iso = `${year_}-${month_}-${day_}T${hour_}:${minute_}:${second_}+09:00`

    const inputDate = new Date(iso)
    const now: Date = new Date()

    return inputDate.getTime() >= now.getTime()
}

/**
 * 윤년이면 2월달수를 전역변수 _dateInfo에 셋팅
 * @param {string | number} sYear 날짜문자열 or 숫자로 된 년도
 * @return  없음
 * @example
 *     setLunar("20160201")
 *
 */
const setLunar = (sYear: string | number): void => {
    const nYear = Number(sYear)
    _dateInfo.arrDay[2] =
        (nYear % 4 === 0 && nYear % 100 !== 0) || nYear % 400 === 0 ? 29 : 28
}

/**
 * 로컬의 현재날짜 및 시간(밀리초 포함) 구하기
 * @param {string} sFormat  날짜 포맷 (기본값: YYYY-MM-DD hh:mm:ss)<br/>
 * 월(MM)은 반드시 대문자, mm(minute)는 소문자로 해야함<br/>
 * 밀리초는 n  으로 표시
 * @return  String  포맷이 적용된 날짜
 * @example
 *     ex1) getLocalDateTime("YYYY/MM/DD hh:mm:ss:n") => '2010/09/01 13:42:22:970'
 *     ex2) getLocalDateTime("YYYYMMDD")              => '20100901'
 *     ex3) getLocalDateTime("hh:mm:ss")              => '13:42:22'
 */
export const getLocalDateTime = (sFormat: string): string => {
    let i: number,
        j: number,
        nIndex = 0
    var str: string | number
    const arrFormat = new Array<string>(7).fill('')
    const arrIndex = new Array<number>(7).fill(0)
    const arrSep = new Array<string>(7).fill('')
    let nSeq = 0
    let bFlag: boolean

    if (isNull(sFormat)) {
        sFormat =
            'YYYY' +
            _dateInfo.yearFormater +
            'MM' +
            _dateInfo.yearFormater +
            'DD hh' +
            _dateInfo.timeFormater +
            'mm' +
            _dateInfo.timeFormater +
            'ss'
    }
    str = sFormat

    for (i = 0; i < str.length; i++) {
        var c = str.charAt(i)

        bFlag = true
        if (c === 'y' || c === 'Y') {
            nSeq = 0
        } else if (c === 'M') {
            nSeq = 1
        } else if (c === 'd' || c === 'D') {
            nSeq = 2
        } else if (c === 'h' || c === 'H') {
            nSeq = 3
        } else if (c === 'm') {
            nSeq = 4
        } else if (c === 's' || c === 'S') {
            nSeq = 5
        } else if (c === 'n' || c === 'N') {
            nSeq = 6
        } else {
            bFlag = false
        }

        if (bFlag) {
            arrFormat[nSeq] += c
            if (arrIndex[nSeq] === 0) {
                nIndex++
                arrIndex[nSeq] = nIndex
            }
        } else {
            arrSep[nSeq] += c
        }
    }

    var today = new Date()
    var yy = today.getFullYear().toString()
    var tm = today.getMonth() + 1
    var td = today.getDate()
    var h = today.getHours()
    var m = today.getMinutes()
    var s = today.getSeconds()
    var ms = '' + today.getMilliseconds()

    var mm = fillZero(tm, 2)
    var dd = fillZero(td, 2)
    var hh = fillZero(h, 2)
    var mi = fillZero(m, 2)
    var ss = fillZero(s, 2)
    ms = fillZero(ms, 3)

    str = ''
    for (i = 0; i < arrFormat.length; i++) {
        for (j = 0; j < arrFormat.length; j++) {
            if (i + 1 == arrIndex[j]) {
                const c = arrFormat[j].charAt(0)
                if (c == 'y' || c == 'Y') {
                    if (arrFormat[j].length == 4) {
                        str += yy
                    } else {
                        str += yy.substring(2, 4)
                    }
                } else if (c == 'M') {
                    str += mm
                } else if (c == 'd' || c == 'D') {
                    str += dd
                } else if (c == 'h' || c == 'H') {
                    str += hh
                } else if (c == 'm') {
                    str += mi
                } else if (c == 's' || c == 'S') {
                    str += ss
                } else if (c == 'n' || c == 'N') {
                    str += ms
                }
                str += arrSep[j]
                break
            }
        }
    }

    return str
}

/**
 *
 * @param param 한글
 * @returns
 */
export const removeSpecialCharsAndKorean = (param: string): string => {
    return param.replace(/[^a-zA-Z0-9]/g, '')
}

/**
 * 현재날짜 구하기
 * @param {String:N} format 날짜 포맷 (기본값: YYYYMMDD)
 * @return  String  현재날짜
 * @example
 *     ex1) getLocalDate("YYYY/MM/DD") => 2010/09/01
 *     ex2) getLocalDate()             => 20100901
 */
export const getLocalDate = function (format) {
    var ret = ''
    var sFormat = 'YYYYMMDD'

    if (!isNull(format)) {
        sFormat = format
    }
    ret = getLocalDateTime(sFormat)

    return ret
}

/**
 * 현재시간(밀리초 포함) 구하기
 * @param {String:N} format 시간 포맷 (기본값: hhmmss)
 * @return  String  현재시간
 * @example
 *     ex1) getLocalTime("hh:mm:ss:n") => 15:09:03:562
 *     ex2) getLocalTime("hh:mm:ss")   => 15:09:03
 *     ex3) getLocalTime()             => 150903
 */
export const getLocalTime = function (format) {
    var ret = ''
    var sFormat = 'hhmmss'

    if (!isNull(format)) {
        sFormat = format
    }
    ret = getLocalDateTime(sFormat)

    return ret
}

/**
 * 날짜 및 시간 유효성 검사(년월일 or 년월일시분 or 년월일시분초)
 * @param {String:Y} sInDate 날짜문자열
 * @return  Boolean
 * @example
 *     ex1) checkValidDate("20170401")
 *     ex2) checkValidDate("20170401115021")
 */
export const checkValidDate = function (sInDate) {
    var sDate = getNumberOnly(sInDate)
    var yy, mm, dd

    if (sDate.length < 6) {
        return false
    }

    yy = parseInt(sDate.substring(0, 4), 10)
    mm = parseInt(sDate.substring(4, 6), 10)
    if (yy <= 1900) {
        return false
    }
    if (mm < 1 || mm > 12) {
        return false
    }
    if (sDate.length == 8) {
        dd = parseInt(sDate.substring(6, 8), 10)
        setLunar(yy)
        if (dd < 1 || dd > _dateInfo.arrDay[mm]) {
            return false
        }
        if (sDate.length >= 12) {
            var time = sDate.substring(8)
            return checkValidTime(time)
        }
    }

    return true
}

/**
 * 날짜 범위의 유효성 검사(시작/종료년월일)
 * @param {String:Y} sFrDate 시작일자
 * @param {String:Y} sToDate 종료일자
 * @return  Boolean
 * @example
 *     checkValidFromToDate("20170101", "20171201")
 */
// export const checkValidFromToDate = function (sFrDate, sToDate) {
//     var frDate = getNumberOnly(sFrDate);
//     var toDate = getNumberOnly(sToDate);

//     if (frDate.length == 0 && toDate.length == 0) {
//         return  true;
//     }
//     if (!(frDate.length == 6 || frDate.length == 8 || toDate.length == 6 || toDate.length == 8)) {
//         return  false;
//     }
//     if (frDate.length != toDate.length) {
//         return  false;
//     }

//     if (!checkValidDate(frDate))  return  false;
//     if (!checkValidDate(toDate))  return  false;

//     if (parseInt(frDate, 10) > parseInt(toDate, 10)) {
//         return  false;
//     }

//     return  true;
// };

/**
 * 시간 유효성 검사(시분초)
 * @param {String:Y} sInTime 시간
 * @return  Boolean
 * @example
 *     checkValidTime("1121")
 */
const checkValidTime = function (sInTime) {
    var sTime = getNumberOnly(sInTime)
    var hh,
        mm,
        ss = 0

    if (!(sTime.length == 6 || sTime.length == 4)) {
        return false
    }

    hh = parseInt(sTime.substring(0, 2), 10)
    mm = parseInt(sTime.substring(2, 4), 10)
    if (sTime.length == 6) {
        ss = parseInt(sTime.substring(4, 6), 10)
    }

    if (hh < 0 || hh > 23) {
        return false
    }
    if (mm < 0 || mm > 59) {
        return false
    }
    if (sTime.length == 6) {
        if (ss < 0 || ss > 59) {
            return false
        }
    }

    return true
}

/**
 * 날짜 문자열중 포맷(/, -등)을 제외한 숫자들을 반환 (년월일)
 * @param {string} sDate 날짜
 * @return  숫자로만 된 날짜
 * @example
 *     getFormatDate("2017-05-06")
 */
export const getFormatDate = (sDate: string): string => {
    return getNumberOnly(sDate)
}

/**
 * 날짜 문자열을 포맷(.)을 포함해서 반환 (년월일)
 * @param {String:Y} sDate 날짜
 * @return  String 포맷된 날짜
 * @example
 *     setFormatDate("20170508")
 */
export const setFormatDate = (sDate: string): string => {
    let date = getNumberOnly(sDate)

    if (date.length != 8) {
        return ''
    }
    date =
        date.substring(0, 4) +
        _dateInfo.yearFormater +
        date.substring(4, 6) +
        _dateInfo.yearFormater +
        date.substring(6, 8)

    return date
}

/**
 * 날짜 문자열을 포맷(.)을 포함해서 반환 (년월일)
 * @param {String:Y} sDate 날짜
 * @return  String 포맷된 날짜
 * @example
 *     setbirthDate("170508")
 */
export const setbirthDate = (sDate: string): string => {
    let date = getNumberOnly(sDate)

    if (date.length != 6) {
        return ''
    }
    date =
        '19' +
        date.substring(0, 2) +
        _dateInfo.yearFormater +
        date.substring(2, 4) +
        _dateInfo.yearFormater +
        date.substring(4, 6)

    return date
}

/**
 * 시간 문자열을 포맷(:)을 포함해서 반환 (시분초)
 * @param {string} sTime 시간
 * @return  포맷된 시간
 * @example
 *     setFormatTime("054512")
 */
export const setFormatTime = (sTime: string): string => {
    let time = ''
    const numberOnlyTime = getNumberOnly(sTime)

    if (numberOnlyTime.length != 6 && numberOnlyTime.length != 4) {
        return ''
    }
    time =
        numberOnlyTime.substring(0, 2) +
        _dateInfo.timeFormater +
        numberOnlyTime.substring(2, 4)

    if (numberOnlyTime.length == 6) {
        time += _dateInfo.timeFormater + numberOnlyTime.substring(4, 6)
    }

    return time
}

/**
 * 요일에 대한 문자 구하기
 * @param {Number:Y} weekIndex 요일의 index(0 ~ 6,  0: 일요일, 6: 토요일)
 * @param {String:N} type 요일구분(E:영문, K:한글)
 * @return  String 요일문자
 * @example
 *     getStringOfWeek(0);
 * @deprecated TODO: 사용여부 확인!
 */
export const getStringOfWeek = function (weekIndex, type) {
    var mode = typeof type == 'undefined' ? 'E' : type

    if (mode == 'K') return _dateInfo.arrWeekStr[weekIndex]

    return _dateInfo.arrWeekEngStr[weekIndex]
}

/** */
export const formatKoreanCurrency = (amount: string | number) => {
    const targetAmount = typeof amount === 'string' ? Number(amount) : amount

    if (targetAmount >= 100000000) {
        return targetAmount / 100000000 + '억원'
    } else if (targetAmount >= 10000) {
        return targetAmount / 10000 + '만원'
    } else if (targetAmount >= 1000) {
        return targetAmount / 1000 + '천원'
    } else {
        return targetAmount + '원'
    }
}

/**
 * 숫자로 된 금액을 한글로 변환
 * @param {String:Y} n 문자열
 * @return  String 한글문자열
 * @example
 *     var str = priceToHan("123456") => 일십이만삼천사백오십육
 */
export const priceToHan = function (n) {
    var txtAmnt = ''

    if (typeof n == 'number') n = '' + n
    if (n.length > 16) return n

    var aNum = '123456789' // 입력비교값
    var aStr = '일이삼사오육칠팔구' // 출력비교값
    var idx = 0 // 입력 문자열의 자릿수
    var edVal = '' // 자릿수별 값
    var sumVal = 0 // 천단위씩(천백십일) 더한값

    for (var i = 0; i < n.length; i++) {
        idx = n.length - i
        edVal = n.charAt(i)
        sumVal += Number(edVal)
        txtAmnt += aStr.charAt(aNum.indexOf(edVal))

        var mod = idx % 4
        if (mod == 0 || mod == 3 || mod == 2) {
            if (Number(edVal) != 0) {
                if (mod == 0) txtAmnt += '천'
                else if (mod == 3) txtAmnt += '백'
                else if (mod == 2) txtAmnt += '십'
            }
        } else {
            if (sumVal > 0) {
                if (idx == 5) {
                    txtAmnt += '만'
                } else if (idx == 9) {
                    txtAmnt += '억'
                } else if (idx == 13) {
                    txtAmnt += '조'
                } else if (idx == 17) {
                    txtAmnt += '경'
                }
            }
            sumVal = 0 // 다음 4자리수를 더하기 위해 초기화
        }
    }

    return txtAmnt
}

/**
 * 주민등록번호 검사
 * @param {String:Y} regNo 13자리 또는 '-' 포함 14자리 주민등록번호
 * @return  Boolean
 * @example
 *     regCheck("8012052145247")
 */
export const regCheck = function (regNo) {
    var sReg = regNo.trim()
    var nSum = 0
    var nChk = 2

    sReg = getNumberOnly(sReg)

    if (sReg.length != 13) {
        return false
    }

    for (var i = 0; i < sReg.length - 1; i++) {
        var c = sReg.charAt(i)

        nSum += parseInt(c, 10) * nChk
        nChk = nChk == 9 ? 2 : nChk + 1
    }

    if (parseInt(sReg.substring(12, 13), 10) != (11 - (nSum % 11)) % 10) {
        return false
    }

    return true
}

/**
 * 이메일주소검사
 * @param {string} str 이메일주소
 * @return
 * @example
 *     checkMail("hong@gmail.com")
 */
export const checkMail = (str: string): boolean => {
    if (!isNull(str)) {
        const format =
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/

        return format.test(str)
    }
    return true
}

/**
 * 전화번호 검사
 * @param {string} no1 전화번호1 또는 전체 전화번호
 * @param {string} no2 전화번호2
 * @param {string} no3 전화번호3
 * @return
 * @example
 *     ex1) checkTelNo("02-123-4567")
 *     ex2) checkTelNo("021234567")
 *     ex3) checkTelNo("02", "1234", "567")
 */
export const checkTelNo = (
    no1: string,
    no2?: string,
    no3?: string
): boolean => {
    let sTelNo1 = ''
    let sTelNo2 = ''
    let sTelNo3 = ''

    if (isNull(no2)) {
        // 전화번호가 1개
        var no = getNumberOnly(no1)

        if (no.length == 0) return true
        if (no.length < 9 || no.length > 11) return false

        if (no.substring(0, 2) == '02') {
            sTelNo1 = no.substring(0, 2)
            sTelNo3 = no.substring(no.length - 4, no.length)
            sTelNo2 = no.substring(2, no.length - 4)
        } else if (no.substring(0, 4) == '0502') {
            sTelNo1 = no.substring(0, 4)
            sTelNo3 = no.substring(no.length - 4, no.length)
            sTelNo2 = no.substring(4, no.length - 4)
        } else {
            sTelNo1 = no.substring(0, 3)
            sTelNo3 = no.substring(no.length - 4, no.length)
            sTelNo2 = no.substring(3, no.length - 4)
        }
    } else {
        sTelNo1 = getNumberOnly(no1)
        sTelNo2 = getNumberOnly(no2)
        sTelNo3 = getNumberOnly(no3)
    }

    if (sTelNo1.length == 0 && sTelNo2.length == 0 && sTelNo2.length == 0)
        return true

    if (
        sTelNo1.length < 2 ||
        sTelNo2.length < 3 ||
        sTelNo2.length > 4 ||
        sTelNo3.length != 4
    ) {
        return false
    }
    return [
        '011',
        '010',
        '016',
        '017',
        '018',
        '019',
        '02',
        '031',
        '032',
        '033',
        '041',
        '042',
        '043',
        '044',
        '051',
        '052',
        '053',
        '054',
        '055',
        '061',
        '062',
        '063',
        '064',
        '070',
        '0502',
    ].includes(sTelNo1)
}

/**
 * PDF 파일명 암호화
 * @param vPath
 * @return
 * @example
 *     cipherPath()
 */
export const cipherPath = function (vPath) {
    // var json = {
    //     path: vPath, //010
    // }
    // //com_utl_010101_2
    // var opt = {
    //     pkg: 'com',
    //     userCallBack: 'comUtil.oncipherPathCallback',
    //     errorCallBack: 'comUtil.errcipherPathCallback',
    //     subPkg: 'utl',
    //     async: false, //true:비동기, false:동기
    //     svc: '010101_2',
    // }
    // webUtil.callSubmitJson(opt, json)
}

//PDF 뷰어 호출을 위한 파일명 암호화 변수
var vEncPdfPath = ''
var vPdfErr = false

const oncipherPathCallback = function (data) {
    vEncPdfPath = data.encData
    vPdfErr = false
}

const errcipherPathCallback = function (data) {
    vPdfErr = true
}

/**
 * XML 약관 팝업
 * @date 2018.09.10
 * @memberOf comUtil
 * @param
 * @return
 * @example
 *     showAgreementXML()
 */
// comUtil.showAgreementXML = function (popOpt) {
//     var popObj = typeof popOpt == 'string' ? JSON.parse(popOpt) : popOpt

//     var vtitle = popObj.title || '약관보기'
//     var vId = popObj.id || ''
//     var vA_id = popObj.a_id || ''
//     var vBtn01 = popObj.btnConform || ''
//     var vBtn02 = popObj.btnCancel || ''
//     var vCallback = popObj.callback || 'scwin.fn_afterModalPps' //callback 미지정시 scwin.fn_afterModalPps 보냄

//     var obj = {
//         //width: 400 ,
//         //height: 600 ,
//         //url:"/ibs/PILOT/nfrc/ui/popup/popup.xml"
//         //style : "width:100%; height:100%;"
//         url: '/ibs/nfrc/ui/com/terms_layout.xml',
//         title: vtitle,
//         id: vId, //"fullpopty01" : 하이트, "fullpopty02" : black
//         popupParam: {
//             tdata: vtitle,
//             data: vA_id,
//             btn01: vBtn01,
//             btn02: vBtn02,
//             callback: vCallback,
//         },
//     }

//     webUtil.openCommonPopup(obj)
// }

/**
 * PDF 약관 팝업
 * @date 2018.09.10
 * @memberOf comUtil
 * @param
 * @return
 * @example
 *     showAgreementPDF()
 */
// comUtil.showAgreementPDF = function (popOpt) {
//     var popObj = typeof popOpt == 'string' ? JSON.parse(popOpt) : popOpt

//     var vtitle = popObj.title || '약관보기'
//     var vId = popObj.id || ''
//     var vA_url = popObj.a_url || ''
//     var vBtn01 = popObj.btnConform || ''
//     var vBtn02 = popObj.btnCancel || ''
//     var vCallback = popObj.callback || 'scwin.fn_afterModalPps' //callback 미지정시 scwin.fn_afterModalPps 보냄

//     var obj = {
//         //width: 400 ,
//         //height: 600 ,
//         //url:"/ibs/PILOT/nfrc/ui/popup/popup.xml"
//         //style : "width:100%; height:100%;"
//         url: '/ibs/nfrc/ui/com/terms_pdf.xml', //\SMT_ID.war\nfrc\ui\com\terms_layout.xml
//         title: vtitle,
//         id: vId, //"fullpopty01" : 하이트, "fullpopty02" : black
//         popupParam: {
//             tdata: vtitle,
//             data: vA_url,
//             btn01: vBtn01,
//             btn02: vBtn02,
//             callback: vCallback,
//         },
//     }

//     webUtil.openCommonPopup(obj)
// }

/**
 * 여러 약관 동시 팝업
 * @date 2018.09.10
 * @memberOf comUtil
 * @param
 * @return
 * @example
 *     showAgreementALL()
 */
// comUtil.showAgreementALL = function (popOpt) {
//     WebSquare.layer.showProcessMessage('처리중...')

//     var popObj = typeof popOpt == 'string' ? JSON.parse(popOpt) : popOpt

//     var vtitle = popObj.title || '약관보기'
//     var vId = popObj.id || ''
//     var vType = popObj.type || ''
//     var vAddr = popObj.addr || ''
//     var vBtn = popObj.btnConform || ''
//     var vCallback = popObj.callback || 'scwin.fn_afterModalPps' //callback 미지정시 scwin.fn_afterModalPps 보냄

//     var obj = {
//         //width: 400 ,
//         //height: 600 ,
//         //url:"/ibs/PILOT/nfrc/ui/popup/popup.xml"
//         //style : "width:100%; height:100%;"
//         url: '/ibs/nfrc/ui/com/terms_all.xml',
//         title: vtitle,
//         id: vId, //"fullpopty01" : 하이트, "fullpopty02" : black
//         popupParam: {
//             titledata: vtitle,
//             typedata: vType,
//             addrdata: vAddr,
//             btn: vBtn,
//             callback: vCallback,
//         },
//     }

//     webUtil.openCommonPopup(obj)
// }

/**
 * 팝업창을 닫는다.
 * iframe으로 연 경우 $w.closePopup()를 사용하고 window.open()으로 연 경우 window.close() 사용
 * @date 2015.08.06
 * @memberOf webUtil
 * @param {String:Y} popId  팝업ID
 * @param {String:N} callBackFnc  콜백함수
 * @param {Object:N} param  부모창에 넘길 파라메터
 */
// comUtil.closePopup = function (popId, callBackFnc, param) {
//     //;

//     $('html').removeClass('w2modalopenedbody')

//     var popType = opener || parent
//     // frameSet 으로 감쌋을 때.
//     var isFrame = false

//     try {
//         isFrame =
//             typeof top.window.frames['_content'] !== 'undefined' ? true : false
//     } catch (e) {}

//     if (typeof callBackFnc != 'undefined' && callBackFnc.length > 0) {
//         if (isFrame) {
//             top.window.frames['_content'].eval(callBackFnc)(param)
//         } else {
//             try {
//                 popType.eval(callBackFnc)(param)
//             } catch (e) {
//                 $w.closePopup(popId)

//                 if (callBackFnc == 'scwin.fn_afterModalPps') {
//                     scwin.fn_afterModalPps(param)
//                 }
//                 if (callBackFnc == 'scwin.btn_okCallback') {
//                     scwin.btn_okCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.btn_okCallback2') {
//                     scwin.btn_okCallback2(param)
//                 }
//                 if (callBackFnc == 'scwin.digitalOtpAgreeOpenPopupCallback') {
//                     scwin.digitalOtpAgreeOpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.agreeYnOpenPopupCallback') {
//                     scwin.agreeYnOpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.cb_afterAllAgree') {
//                     scwin.cb_afterAllAgree(param)
//                 }
//                 if (callBackFnc == 'scwin.agreeAllCheckOpenPopupCallback') {
//                     scwin.agreeAllCheckOpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.agree1OpenPopupCallback') {
//                     scwin.agree1OpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.agree2OpenPopupCallback') {
//                     scwin.agree2OpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.agreeOpenPopupCallback') {
//                     scwin.agreeOpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.all_agree_base_OpenPopupCallback') {
//                     scwin.all_agree_base_OpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.all_agreeOpenPopupCallback') {
//                     scwin.all_agreeOpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.agree_OpenPopupCallback') {
//                     scwin.agree_OpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.agree1_OpenPopupCallback') {
//                     scwin.agree1_OpenPopupCallback(param)
//                 }
//                 if (callBackFnc == 'scwin.cb_after103Detail') {
//                     scwin.cb_after103Detail(param)
//                 }
//                 if (callBackFnc == 'scwin.cb_after101Detail') {
//                     scwin.cb_after101Detail(param)
//                 }
//                 if (callBackFnc == 'scwin.cb_after103Agree') {
//                     scwin.cb_after103Agree(param)
//                 }
//                 if (callBackFnc == 'scwin.cb_after101Agree') {
//                     scwin.cb_after101Agree(param)
//                 }
//                 if (callBackFnc == 'scwin.popupStplDetailCallback') {
//                     scwin.popupStplDetailCallback(param)
//                 }
//             }
//         }
//     }

//     if (popType == opener) {
//         $w.closePopup(popId)
//     } else {
//         if (typeof popId != 'undefined' && popId != null) {
//             if (isFrame) {
//                 top.window.frames['_content'].$w.closePopup(popId)
//             } else {
//                 $w.closePopup(popId)
//             }
//         }
//     }
// }

/**
 * 서버 시간을 반환한다. ::: TOBE 변환필요
 * @return {string} 서버시간
 * @deprecated TODO: 사용여부 확인!
 */
export const getServerTIME = (): string => {
    // var vRst = ''
    // var json = {}
    // var opt = {
    //     pkg: 'com',
    //     subPkg: 'utl',
    //     svc: '010101_1',
    //     async: false,
    // }
    // webUtil.transCallAjax(opt, json, function (data) {
    //     // 에러인 경우
    //     if (data._is_error) {
    //         if (typeof wfm_content != 'undefined') {
    //             app.showAlarmPopup('', data['_error_msg'])
    //         } else {
    //             alert(data['_error_msg'])
    //         }
    //     } else {
    //         //성공시
    //         vRst = data.currentTime
    //     }
    // })
    // return vRst
    return ''
}

/**
 * 비밀번호를 비교한다.
 * @param {object} json 비밀번호 체크할 파라메터
 * @deprecated TODO: 사용여부 확인!
 */
export const comparePwd = (json: object): boolean => {
    // var vRst = false
    // var opt = {
    //     pkg: 'com',
    //     subPkg: 'utl',
    //     svc: '010101_4',
    //     async: false,
    // }
    // webUtil.transCallAjax(opt, json, function (data) {
    //     // 에러인 경우
    //     if (data._is_error) {
    //         if (typeof wfm_content != 'undefined') {
    //             app.showAlarmPopup('', data['_error_msg'])
    //         } else {
    //             alert(data['_error_msg'])
    //         }
    //     } else {
    //         //성공시
    //         vRst = data.isEqual
    //     }
    // })
    // return vRst
    return false
}

/**
 * 소수점 자리 표시 + 정규식 3자리마다 ,를 붙임
 * @param {string} dat
 * @returns
 * @deprecated Number(0).toLocaleString('ko-KR') 사용
 */
export const decimal = (dat: string): string => {
    if (isEmpty(dat)) return ''
    if (dat.indexOf(',') > 0) return dat
    var nums = dat.split('.')
    if (typeof nums[0] == 'string') nums[0] = String(Number(nums[0]))
    else if (typeof nums[0] == 'number') nums[0] = String(nums[0])

    var reg = /(^[+-]?\d+)(\d{3})/ // 정규식(3자리마다 ,를 붙임)
    nums[0] += '' // ,를 찍기 위해 숫자를 문자열로 변환
    while (reg.test(nums[0]))
        // nums[0]값의 첫째자리부터 마지막자리까지
        nums[0] = nums[0].replace(reg, '$1' + ',' + '$2') // 인자로 받은 nums[0] 값을 ,가 찍힌 값으로 변환시킴

    if (nums.length <= 1) {
        return nums[0]
    }

    return nums[0] + '.' + nums[1] // 바뀐 dat 값을 반환.
}

/**
 * 정규식 3자리마다 ,를 붙임
 * @param {string} dat
 * @returns
 * @deprecated Number(0).toLocaleString('ko-KR') 사용
 */
export const number = (dat: string): string => {
    if (isEmpty(dat)) return ''
    if (dat == null) return ''

    if (typeof dat == 'string') {
        dat = dat.replace(/[^0-9.-]/g, '')
        if (0 == dat.indexOf('-')) {
            dat = dat.replace(/[-]/g, '')
            dat = '-' + dat
        } else {
            dat = dat.replace(/[-]/g, '')
        }
        dat = String(Number(dat))
    } else if (typeof dat == 'number') {
        dat = String(dat)
    }

    dat = dat.replace(',', '')

    const reg = /(^[+-]?\d+)(\d{3})/ // 정규식(3자리마다 ,를 붙임)
    dat += '' // ,를 찍기 위해 숫자를 문자열로 변환
    while (reg.test(dat))
        // dat값의 첫째자리부터 마지막자리까지
        dat = dat.replace(reg, '$1' + ',' + '$2') // 인자로 받은 dat 값을 ,가 찍힌 값으로 변환시킴

    return dat // 바뀐 dat 값을 반환.
}

/**
 * 필드값에서 특정 문자열 제거
 * @param {string} val
 * @param {string} str
 * @returns
 * @deprecated TODO: 사용여부 확인!
 */
export const removeStr = (val: string, str: string): string => {
    const regexp = new RegExp(str, 'g')
    return val.replace(regexp, '')
}

/**
 * 휴대폰 번호  (010-1234-1245 or 010-123-1234)
 */
export const teltNumber = (dat) => {
    if (isEmpty(dat)) return ''
    dat = dat.trim()
    dat = dat.replace(/-/g, '')

    if (dat.length == 11) {
        dat =
            dat.substring(0, 3) +
            '-' +
            dat.substring(3, 7) +
            '-' +
            dat.substring(7, 11)
        return dat
    } else if (dat.length == 10) {
        dat =
            dat.substring(0, 3) +
            '-' +
            dat.substring(3, 6) +
            '-' +
            dat.substring(6, 10)
        return dat
    } else return dat
}

/**
 * 계좌번호를 표시형식으로 변환.
 * @param account
 * @returns
 */
export const convertAccountFormat = (account: string): string => {
    var result = ''
    if (account == null) return ''

    if (account.length == 14) {
        // 일반계좌번호
        result += account.substring(0, 3)
        result += '-'
        result += account.substring(3, 9)
        result += '-'
        result += account.substring(9, 11)
        result += '-'
        result += account.substring(11, 14)
    } else if (account.length == 16) {
        // 외화계좌번호
        result += account.substring(0, 3)
        result += '-'
        result += account.substring(3, 9)
        result += '-'
        result += account.substring(9, 11)
        result += '-'
        result += account.substring(11, 16)
    }
    return result
}

/**
 * 특정일로부터 날짜 더하기
 * adat = 2013-01-01
 * _year	: + 년도
 * _month	: + 달
 * _day		: + 일짜
 * 반환 = 20130101
 */
export const addShiftDate = function (adat, _year, _month, _day) {
    var _newDate = new Date()

    _newDate.setFullYear(adat.substr(0, 4))
    _newDate.setMonth(adat.substr(4, 2) - 1)
    _newDate.setDate(adat.substr(6, 2))

    var _rDate = new Date()
    _rDate.setFullYear(_newDate.getFullYear() + _year)
    _rDate.setMonth(_newDate.getMonth() + _month)
    _rDate.setDate(_newDate.getDate() + _day)

    return dateFormattingWithParams(
        _rDate.getFullYear(),
        _rDate.getMonth() + 1,
        _rDate.getDate()
    )
}

const dateFormattingWithParams = function (year, month, day) {
    var d = new Array(year + '', month + '', day + '')
    var str = ''

    for (var i = 0; i < d.length; i++) {
        if (d[i].length == 1) str += '0' + d[i]
        else str += d[i]
    }
    return str
}

export const cutProdName = (nm: string): string => {
    let returnNm = nm

    if (returnNm.indexOf('(') > -1) {
        returnNm = returnNm.substring(0, returnNm.indexOf('('))
    } else if (returnNm.indexOf('[') > -1) {
        returnNm = returnNm.substring(0, returnNm.indexOf('['))
    }

    return returnNm
}

export const replaceProdName = (nm: string): string => {
    let returnNm = nm

    if (returnNm.indexOf('[개인]') > -1) {
        returnNm = returnNm.replace('[개인]', '')
    } else if (returnNm.indexOf('(개인)') > -1) {
        returnNm = returnNm.replace('(개인)', '')
    } else if (returnNm.indexOf('[체크]') > -1) {
        returnNm = returnNm.replace('[체크]', '')
        if (returnNm.indexOf('학생증') > -1) {
            returnNm = returnNm.replace('학생증', '<br>학생증')
        }
    } else if (returnNm.indexOf('(체크)') > -1) {
        returnNm = returnNm.replace('(체크)', '')
        if (returnNm.indexOf('학생증') > -1) {
            returnNm = returnNm.replace('학생증', '<br>학생증')
        }
    } else if (returnNm.indexOf('(적립식)') > -1) {
        returnNm = returnNm.replace('(적립식)', '')
    } else if (returnNm.indexOf('[적립식]') > -1) {
        returnNm = returnNm.replace('[적립식]', '')
    } else if (returnNm.indexOf('(입출금식)') > -1) {
        returnNm = returnNm.replace('(입출금식)', '')
    } else if (returnNm.indexOf('[입출금식]') > -1) {
        returnNm = returnNm.replace('[입출금식]', '')
    } else if (returnNm.indexOf('((구) i-ONE 직장인명함대출)') > -1) {
        returnNm = returnNm.replace('((구) i-ONE 직장인명함대출)', '')
    }

    return returnNm
}

/**
 * 접속환경 반환
 * @return 접속환경타입(I : IOS, A : ANDROID, W : WEB)
 */
export const getDeviceType = (): string => {
    let deviceType = 'W'
    const userAgent = navigator.userAgent

    if (
        userAgent.indexOf('iPhone') != -1 ||
        userAgent.indexOf('iPod') != -1 ||
        userAgent.indexOf('iPad') != -1
    ) {
        deviceType = 'I'
    } else if (userAgent.indexOf('Android') != -1) {
        deviceType = 'A'
    }

    return deviceType
}

/**
 * 모바일기기 접속여부 반환
 * @return {Boolean} 모바일기기 여부
 */
export const isMobile = (): boolean => {
    const deviceType = getDeviceType()
    return deviceType === 'I' || deviceType === 'A'
}

/*
 * 사용자 데이터 저장
 * @param {String:Y} key 저장 키
 * @param {Object:N} obj 저장 데이터
 * @return {Object} 사용자 데이터
 */
export const setUserData = function (key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
}

/*
 * 사용자 데이터 반환
 * @param {String:Y} key 데이터를 꺼내올 키값
 * @param {Boolean:N} isDel 데이터를 꺼내오면서 삭제할지 여부
 * @return {Object} 사용자 데이터
 */
export const getUserData = function (key, isDel) {
    const obj = JSON.parse(localStorage.getItem(key))

    if (typeof isDel != 'undefined' && isDel === true) {
        localStorage.removeItem(key)
    }

    return obj
}

/*
 *   이어하기 날짜 포멧
 *  'YYYY.MM.DD HH:mm'
 */
export const cvDateTime = (yyyymmdd: string, hhmmss: string) => {
    return moment(yyyymmdd + hhmmss, 'YYYYMMDDHHmmSS').format(
        'YYYY.MM.DD HH:mm'
    )
}

/*
 * i-ONE 뱅크 앱으로 이동
 * @param {string} paramStr 파라미터 쿼리스트링
 */
export const goIOneBank = (paramStr?: string): void => {
    if (isMobile()) {
        // 모바일
        let appUrl = 'https://onebank.ibk.co.kr:443/ibs/jsp/com/comWeb2App.jsp'

        if (!isEmpty(paramStr)) {
            // 부가정보가 있을경우
            appUrl += `?${paramStr}`
        }
        //TODO: 이거 먹나?
        window.open(appUrl, '_blank')
    }
}

/*
 * 서비스 모드 조회
 * @return 서비스 모드 조회
 */
export const getAppMode = (): string => {
    return process.env.REACT_APP_MODE
}

/*
 * 운영서비스 여부
 * @return 운영서비스 여부
 */
export const isRealApp = (): boolean => {
    return getAppMode() === 'production'
}

/*
 * 요청 길이에 해당하는 난수번호 가져오기
 * @param {number} len 난수길이
 * @return 난수번호
 */
export const getRandomNumber = (len: number): string => {
    const array = new Uint8Array(len)

    crypto.getRandomValues(array)

    const ramdomNumber = Array.from(array)
        .map((value) => value % 10)
        .join('')

    return ramdomNumber
}

const dec2hex = (dec: number) => {
    return dec.toString(16).padStart(2, '0')
}
export const getRandomString = (len: number): string => {
    const array = new Uint8Array((len || 40) / 2)

    crypto.getRandomValues(array)

    const randomString = Array.from(array, dec2hex).join('')

    return randomString
}
/**
 * ????
 * @returns
 */
export const getImgUrl = (): string => {
    return isRealApp()
        ? process.env.REACT_APP_IMG_URL
        : process.env.REACT_APP_TEST_IMG_URL
}

export const getNfchPrcfGrpCd = (allPdcd?: string): string => {
    let result = ''
    if (!allPdcd) return result

    // 상품정보 재설정
    const pdlnCd = allPdcd.substring(0, 2)
    const pdgrCd = allPdcd.substring(2, 4)
    const pdtmCd = allPdcd.substring(4, 7)
    // const pdcd = allPdcd.substr(7);

    // 예금 대분류그룹코드
    if (pdlnCd == '01' && pdgrCd == '11') {
        result = '103'
    }
    // 적금 대분류그룹코드
    else if (pdlnCd == '01' && pdgrCd == '21') {
        if (pdtmCd === '121') {
            //적금
            result = '101'
        } else if (pdtmCd === '129') {
            //청약
            result = '104'
        } else if (pdtmCd === '131') {
            //예금
            result = '102'
        }
    }
    // 예금(중금채) 대분류그룹코드
    else if (pdlnCd == '01' && pdgrCd == '51') {
        result = '102'
    }

    // 스마트뱅킹 대분류그룹코드
    else if (pdlnCd == '04' && pdgrCd == '11') {
        result = '401'
    }
    // 체크 대분류그룹코드
    else if (pdlnCd == '12' && pdgrCd == '11') {
        result = '302'
    }
    // 대출 대분류그룹코드
    else if (pdlnCd == '02' && pdgrCd == '21') {
        result = '600'
    }

    return result
}

export const replaceTextToHtmlTag = (target: string): string => {
    if (isEmpty(target)) {
        return
    }
    let replacedText = target
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&apos;/gi, "'")
        .replace(/&quot;/gi, '"')
        .replace(/&amp;/gi, '&')

    return replacedText
}
/**
 * 주어진 문자열에 %s를 찾아 주어진 문자로 교체한다.
 * @param str - 원본 문자열
 * @param args - placeholder에 대치될 문자 or 숫자. 순서대로 추가. 갯수가 맞지 않으면 ''으로 변경된다.
 */
export const getMsg = (str: string, ...args: (string | number)[]) => {
    let i = 0
    return str.replace(/%s/g, () => String(args[i++] ?? ''))
}

export const isNumber = (value: any) => {
    if (!value) return true
    return /^\d+$/.test(value)
}

export const isLocal = getAppMode() === 'local'

/**
 * 우편번호 포맷
 * @param str
 * @returns
 */
export const formatZipCode = (str: string) => {
    if (isEmpty(str)) {
        return
    }
    let result = ''

    if (CF_trim(str).length == 6) {
        result = str.substring(0, 3) + '-' + str.substring(3, 6)
    } else {
        result = str
    }
    return result
}

/**
 * string 트림
 *
 */
export const CF_trim = (str: string) => {
    //정규 표현식을 사용하여 화이트스페이스를 빈문자로 전환
    str = str.replace(/^\s*/, '').replace(/\s*$/, '')
    return str //변환한 스트링을 리턴.
}

// 디바이스 체크 함수들 (Context 불필요)
export const isMobileDevice = () => {
    return navigator.userAgent.match(
        /Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/
    )
}

export const isTabletDevice = () => {
    const isTabletOrPc =
        !navigator.userAgent.match(
            /Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/
        ) || navigator.userAgent.match(/iPad/)
    return isTabletOrPc && isMobileDevice()
}
